import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useState, useRef, useCallback } from 'react';

// `to` — detail page link; callers in a scoped list (e.g. My Drives) pass their own
const Drive = ({ drive, to = `/all_drives/drive/${drive._id}` }) => {
  const navigate = useNavigate();

  // Tooltip state
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const tooltipTimer = useRef(null);

  const handleMouseEnter = useCallback(() => {
    tooltipTimer.current = setTimeout(() => setTooltipVisible(true), 1000);
  }, []);

  const handleMouseLeave = useCallback(() => {
    clearTimeout(tooltipTimer.current);
    setTooltipVisible(false);
  }, []);

  const handleMouseMove = useCallback((e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  }, []);

  return (
    <>
    <Card
      className='mb-3 shadow-sm'
      role='link'
      tabIndex={0}
      onClick={() => {
        clearTimeout(tooltipTimer.current);
        setTooltipVisible(false);
        navigate(to);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') event.currentTarget.click();
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      style={{ cursor: 'pointer' }}
    >
      <Card.Body>
        <Row className='align-items-center'>
          {/* Drive Info */}
          <Col md={5} className='wrap_early-1'>
            <h5 className='mb-0 text-primary'>
              {drive.model}
            </h5>
            <div className='small text-muted'>
              {drive.make}
              {drive.type && ` · ${drive.type}`}
              {drive.interface && ` · ${drive.interface}`}
            </div>
            {drive.capacity && (
              <div className='small text-muted'>
                {drive.capacity}
              </div>
            )}
          </Col>

          {/* Performance Metrics */}
          <Col md={4} className='benchmark__stats'>
            <Row className='benchmark__stats-row'>
              <Col>
                <div className='small text-muted'>READ</div>
                <div className='fw-bold'>
                  {drive.avgReadMBps ? <>{Number(drive.avgReadMBps).toFixed(2)} <span className='fw-normal small'>MB/s</span></> : "--"}
                </div>
              </Col>
              <Col>
                <div className='small text-muted'>WRITE</div>
                <div className='fw-bold'>
                  {drive.avgWriteMBps ? <>{Number(drive.avgWriteMBps).toFixed(2)} <span className='fw-normal small'>MB/s</span></> : "--"}
                </div>
              </Col>
            </Row>
            {drive.statsProfile && (
              <div className='small text-muted mt-1'>
                Profile: {drive.statsProfile}
                {drive.statsAttachment === 'usb' && ' · via USB'}
              </div>
            )}
          </Col>

          {/* Benchmarks count & last benchmark */}
          <Col md={3} className='text-end benchmark__timestamp'>
            <div className='small text-muted'>
              {drive.numBenchmarks != null ? `${drive.numBenchmarks} benchmark${drive.numBenchmarks !== 1 ? 's' : ''}` : ''}
            </div>
            {drive.lastBenchmarkDate && (
              <div className='small text-muted'>
                {new Date(drive.lastBenchmarkDate).toLocaleString([], {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })}
              </div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>

    {/* Mouse-following tooltip */}
    {tooltipVisible && (
      <div
        className='benchmark-tooltip'
        style={{ left: mousePos.x + 14, top: mousePos.y + 14 }}
      >
        View Details
      </div>
    )}
    </>
  );
};

export default Drive;